module.exports = __webpack_public_path__ + "img/button-play.201accee.png";